<template>
  <div
    class="form-check"
    :class="{
      disabled: disabled,
      'form-check_small': small,
      'form-check_white': white,
      'form-check-inline': inline,
    }">
    <label :for="cbId" class="form-check-label">
      <input
        v-bind="$attrs"
        :id="cbId"
        class="form-check-input"
        type="checkbox"
        :disabled="disabled"
        :true-value="trueValue"
        :false-value="falseValue"
        v-model="model"
        :value="value"
      />
      <span class="form-check-sign"></span>
      <slot>
        <span v-if="inline">&nbsp;</span>
      </slot>
    </label>
    <el-tooltip v-if="labelInfo" placement="top" class="form-check-label-info">
      <div slot="content">
        <div v-html="labelInfo" />
      </div>
      <i class="nc-icon nc-alert-circle-i font-16 ml-2 label-info"></i>
    </el-tooltip>
  </div>
</template>

<script>
import { Tooltip } from 'element-ui';

export default {

  model: {
    prop: 'checked',
  },

  components: {
    [Tooltip.name]: Tooltip,
  },

  props: {
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
    value: {
      type: String,
    },
    checked: {
      type: [Array, Boolean, String],
      description: 'Whether checkbox is checked',
    },
    disabled: {
      type: Boolean,
      description: 'Whether checkbox is disabled',
    },
    inline: {
      type: Boolean,
      description: 'Whether checkbox is inline',
    },
    labelInfo: {
      type: String,
      default: '',
    },
    white: Boolean,
    small: Boolean,
  },

  data() {
    return {
      cbId: '',
      touched: false,
    };
  },

  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        if (!this.touched) {
          this.touched = true;
        }
        this.$emit('input', check);
      },
    },
  },

  created() {
    this.cbId = Math.random().toString(16).slice(2);
  },
};
</script>
